module.exports = __webpack_public_path__ + "img/logo-ailem.7cb8a576.png";